import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
import { AppFlowService } from "../services/app-flow/app-flow.service";
import { clientConfig } from "../constant/app.constant";

@Injectable({
  providedIn: "root",
})
export class OrderSelectionRouteGuard  {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private toaster: ToastrService,
    private appFlowService: AppFlowService
  ) {}
  // eslint-disable-next-line unused-imports/no-unused-vars-ts
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let returnOrder: any;
    const appFlow = this.appFlowService.getActiveAppFlow();
    const parent = next.parent.routeConfig.path;
    const current = appFlow.sequence.find((s) => s.path === next.routeConfig.path);
    this.store
      .pipe(select("returnOrder"))
      .pipe(take(1))
      .subscribe((ro) => {
        returnOrder = ro;
      });
    if (
      clientConfig.APPFLOW === "formPostNoOrderB2C" ||
      clientConfig.APPFLOW === "formPostPrePopulatedOrder" ||
      clientConfig.APPFLOW === "loginAppFlowPrePopulated" ||
      clientConfig.APPFLOW === "automaticLoginAppFlow" ||
      clientConfig.APPFLOW === "formPostPrePopulatedOrderTechSupportFlow"
    ) {
      return true;
    }

    if (returnOrder && returnOrder.items && returnOrder.items.length) {
      let isAllItemsValid = true;

      returnOrder.items.every((element) => {
        // return false to break
        isAllItemsValid = !!element.isValid;
        return isAllItemsValid;
      });
      if (isAllItemsValid) {
        return true;
      }
    } else {
      // no items selected
      return this.router.parseUrl(`${parent}/${current.back}`);
    }
  }
}
